import React, { useState } from "react"
import { blokType } from "../../types"
import { StyledTabLabels } from "./partials"
import { Tab, TabProps } from "./Tab"
import Components from "../index"

export interface TabsProps {
  tabs: Array<TabProps>
}

export const TabsCmp: React.FC<TabsProps> = ({ tabs }) => {
  const [activeTab, setActiveTab] = useState<string>(tabs[0].label)
  const activeTabContent = tabs.find((tab) => tab.label === activeTab)?.content
  return (
    <>
      {tabs && (
        <>
          <div>
            <StyledTabLabels>
              {tabs.map((body) => (
                <Tab
                  key={body.label}
                  label={body.label}
                  isActive={activeTab === body.label}
                  onClick={() => setActiveTab(body.label)}
                />
              ))}
            </StyledTabLabels>
          </div>
          <div>
            {activeTabContent &&
              activeTabContent.map((content: blokType) =>
                React.createElement(Components(content.component), {
                  key: content._uid,
                  blok: content,
                })
              )}
          </div>
        </>
      )}
    </>
  )
}
